import React from 'react';
import ModelContainer from './ModelContainer';

import './App.css';

function App() {
	return (
		<div className='App'>
			<ModelContainer />
		</div>
	);
}

export default App;
